import { render, staticRenderFns } from "./GlobalChatbotContainer.vue?vue&type=template&id=7acdd4f4&scoped=true"
import script from "./GlobalChatbotContainer.vue?vue&type=script&lang=js"
export * from "./GlobalChatbotContainer.vue?vue&type=script&lang=js"
import style0 from "./GlobalChatbotContainer.vue?vue&type=style&index=0&id=7acdd4f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acdd4f4",
  null
  
)

export default component.exports